import React from "react";
import { ConfirmModal } from "../../../../components/ui";

/**
 * InspectorSubmitModal Component
 *
 * Confirmation modal for submitting inspector signature.
 * Shows CURRENT TMReport data (not snapshot).
 * Warns user about form locking.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Function} props.onClose - Callback to close modal
 * @param {Function} props.onConfirm - Callback to confirm submission
 * @param {boolean} props.isSubmitting - Whether submission is in progress
 * @param {Object} props.inspector - TMInspector instance with current_report
 */
const InspectorSubmitModal = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting,
  inspector,
}) => {
  // Use current TMReport data (not snapshot)
  const report = inspector?.current_report;

  if (!report) {
    return null;
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Submit Inspector Signature"
      buttonText={isSubmitting ? "Submitting..." : "Submit Signature"}
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          You are about to submit your signature for the following T&M report:
        </p>

        <div className="bg-gray-50 border border-gray-300 rounded p-4">
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div className="font-semibold text-gray-600">T&M ID:</div>
            <div className="text-gray-900">{report.tm_id}</div>

            <div className="font-semibold text-gray-600">Job:</div>
            <div className="text-gray-900">
              {report.job_number} - {report.job_description}
            </div>

            <div className="font-semibold text-gray-600">Date:</div>
            <div className="text-gray-900">
              {report.date_performed
                ? new Date(report.date_performed).toLocaleDateString()
                : "N/A"}
            </div>
          </div>
        </div>

        <div className="bg-yellow-50 border border-yellow-300 rounded p-4">
          <p className="text-sm font-semibold text-yellow-800 mb-2">
            ⚠️ Important:
          </p>
          <ul className="text-sm text-yellow-700 space-y-1 list-disc list-inside">
            <li>
              Once submitted, this form will be <strong>locked</strong> and you
              will not be able to access it again.
            </li>
            <li>
              The project manager will be notified of your signature
              immediately.
            </li>
            <li>This action cannot be undone.</li>
          </ul>
        </div>

        <p className="text-gray-700 font-medium">
          Are you sure you want to proceed?
        </p>
      </div>
    </ConfirmModal>
  );
};

export default InspectorSubmitModal;
